var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconeMontagence16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64.68 52.87"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  x: 42.15,
  y: 39.42,
  width: 4.21,
  height: 11.26
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M17.23,37.68h5.95c.48,0,.87.39.87.87v11.61h6.86V12.88H9.49v37.28s6.86,0,6.86,0v-11.61c0-.48.4-.87.88-.87Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M41.28,37.68h5.95c.48,0,.87.39.87.87v11.61h7.38v-27.33h.08-.08c0-.06,0-.12.02-.17V2.86h-21.79v47.3h6.7v-11.61c0-.48.4-.87.88-.87Z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  x: 18.1,
  y: 39.43,
  width: 4.21,
  height: 11.26
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4161d",
  d: "M56.37.09h0l-24.05.14c-.68,0-1.23.55-1.23,1.23v8.79H8.09c-.68,0-1.23.55-1.23,1.23v40.08c0,.68.55,1.23,1.23,1.23h48.39c.72,0,1.31-.59,1.31-1.31l.02-49.94c0-.39-.15-.75-.42-1.02-.27-.27-.63-.42-1.02-.42ZM22.48,50.86h-4.55v-11.6h4.55v11.6ZM31.08,50.33h-7.2v-11.78c0-.38-.32-.7-.7-.7h-5.95c-.39,0-.7.31-.71.7v11.78h-7.2V12.71h21.76v37.62ZM46.52,50.85h-4.55v-11.6h4.55v11.6ZM55.66,22.68c0,.06-.01.11-.02.16h0v27.5h-7.72v-11.78c0-.39-.31-.7-.7-.7h-5.95c-.39,0-.7.31-.71.7v11.78h-7.04V2.69h22.12v19.99Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4161d",
  d: "M46.21,15.21h5.88c.43,0,.79-.34.79-.78h0v-5.89c0-.44-.35-.79-.79-.79h0s-5.88,0-5.88,0c-.44,0-.79.35-.79.79v5.88c0,.44.36.79.79.79ZM47,9.33h4.3v4.3h-4.3v-4.3Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4161d",
  d: "M46.21,24.85h5.88c.43,0,.79-.35.79-.78h0v-5.89c0-.43-.35-.79-.78-.79,0,0,0,0-.01,0h-5.88c-.44,0-.79.35-.79.79v5.88c0,.44.35.79.79.79ZM47,18.96h4.3v4.3h-4.3v-4.3Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4161d",
  d: "M46.21,34.47h5.88c.43,0,.79-.35.79-.78h0v-5.89c0-.44-.35-.79-.79-.79h-5.88c-.44,0-.79.35-.79.79v5.88c0,.44.35.79.79.79ZM47,28.59h4.3v4.3h-4.3v-4.3Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4161d",
  d: "M37.29,15.21h5.88c.44,0,.79-.35.79-.79v-5.88c0-.44-.35-.79-.79-.79h0s-5.88,0-5.88,0c-.44,0-.79.36-.79.79v5.88c0,.43.35.79.79.79ZM38.07,9.33h4.3v4.3h-4.3v-4.3Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4161d",
  d: "M37.29,24.85h5.88c.44,0,.79-.35.79-.79v-5.88c0-.44-.35-.79-.79-.79h-5.88c-.44,0-.79.36-.79.79v5.88c0,.44.35.79.79.79ZM38.07,18.96h4.3v4.3h-4.3v-4.3Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4161d",
  d: "M37.29,34.47h5.88c.44,0,.79-.35.79-.79v-5.88c0-.44-.35-.79-.79-.79h-5.88c-.44,0-.79.36-.79.79v5.88c0,.44.35.79.79.79ZM38.07,28.59h4.3v4.3h-4.3v-4.3Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4161d",
  d: "M21.73,24.84h5.88c.44,0,.79-.36.79-.79v-5.88c0-.44-.35-.79-.79-.79h-5.88c-.44,0-.79.36-.79.79v5.88c0,.44.35.79.79.79ZM22.51,18.96h4.31v4.3h-4.31v-4.3Z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4161d",
  d: "M21.73,34.47h5.88c.44,0,.79-.36.79-.79v-5.88c0-.44-.35-.79-.79-.79h-5.88c-.44,0-.79.36-.79.79v5.88c0,.44.35.79.79.79ZM22.51,28.59h4.31v4.3h-4.31v-4.3Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4161d",
  d: "M12.8,24.84h5.88c.44,0,.79-.35.79-.79v-5.88c0-.44-.35-.79-.79-.79h-5.88c-.44,0-.79.35-.79.79v5.88c0,.44.35.79.79.79ZM13.59,18.96h4.29v4.3h-4.3v-4.3Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#f4161d",
  d: "M12.8,34.47h5.88c.44,0,.79-.35.79-.79v-5.88c0-.44-.35-.79-.79-.79h-5.88c-.44,0-.79.35-.79.79v5.88c0,.44.35.79.79.79ZM13.59,28.59h4.3v4.3h-4.3v-4.3Z"
})));
export default SvgIconeMontagence16;